import { useEffect } from "react";

/**
 * SEO par page pour une SPA (Create React App) — met à jour <title>,
 * la meta description, Open Graph / Twitter et le lien canonique côté client.
 * Sans dépendance externe.
 */
const SITE = "YB Technical Services";
const BASE = "https://ybtechnicalservices.com";
const DEFAULT_TITLE = "YB Technical Services — Conseil & Développement au Maroc";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : DEFAULT_TITLE;
    const url = `${BASE}${path}`;

    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title ? `${title} · ${SITE}` : SITE);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", title ? `${title} · ${SITE}` : SITE);
    upsertMeta("name", "twitter:description", description);
    setCanonical(url);
  }, [title, description, path]);

  return null;
}
